import React, {useCallback} from "react"
import {PaginatedSelector} from "@/components/paginated-selector/paginated-selector";
import {apiV2} from "@/api/axiosConfig";
import {convertV1ToV2, PaginatedResponse} from "@/types/PaginatedResponse";
import {FilterQueryParams} from "@/components/paginated-selector/filters/types";

type User = {
    id: string;
    profile: {
        firstName: string;
        lastName: string;
    };
    email: string;
}

type UserSelectorSimpleProps = {
    clientID?: string;
    departmentID?: string;
    selectedIDs?: string[];
    setSelectedIDs?: (selectedIDs: string[]) => void;
}

export function UserSelectorSimple({clientID, departmentID, selectedIDs = [], setSelectedIDs}: UserSelectorSimpleProps) {
    const headers = [
        "Name",
        "Email"
    ]

    const getUsers = useCallback(async (search: string, page: number, filterParams?: FilterQueryParams) => {
        const params: any = {
            search: search,
            page: page,
            limit: 10,
            ...filterParams,
        }

        if (clientID) {
            params.clientID = clientID;
        }

        if (departmentID) {
            params.departmentID = departmentID;
        }

        const res = await apiV2.get<PaginatedResponse<any>>("users", {params})

        return convertV1ToV2(res.data, 10)
    }, [clientID, departmentID])

    const getColumns = useCallback((user: User) => {
        return [
            `${user.profile.firstName} ${user.profile.lastName}`,
            user.email
        ]
    }, [])

    return <PaginatedSelector
        headers={headers}
        getItems={getUsers}
        getColumns={getColumns}
        selectedIDs={selectedIDs}
        setSelectedIDs={setSelectedIDs}
        disableSelect={false}
    />
}
